import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarNine: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M7 10.6951H9.80304V9.81079C9.80304 9.26013 10.2512 8.81373 10.8041 8.81373H20.1556C20.7084 8.81373 21.1566 8.36734 21.1566 7.81668V7.01903C21.1566 6.46837 20.7084 6.02197 20.1556 6.02197L10.8041 6.02197C10.2512 6.02197 9.80304 6.46837 9.80304 7.01903V7.71698C9.80304 8.26764 9.35483 8.71404 8.80194 8.71404H8.00108C7.4482 8.71404 7 9.16041 7 9.71107V10.6951Z"
      fill={color}
    />
    <path
      d="M7 10.6951H9.80304V11.5794C9.80304 12.1301 10.2512 12.5765 10.8041 12.5765H20.1556C20.7084 12.5765 21.1566 13.0228 21.1566 13.5735V14.3712C21.1566 14.9218 20.7084 15.3682 20.1556 15.3682H10.8041C10.2512 15.3682 9.80304 14.9218 9.80304 14.3712V13.6732C9.80304 13.1226 9.35483 12.6762 8.80194 12.6762H8.00108C7.4482 12.6762 7 12.2298 7 11.6791V10.6951Z"
      fill={color}
    />
    <path
      d="M25 10.6951H22.197V9.81079C22.197 9.26013 21.7488 8.81373 21.1959 8.81373H11.8445C11.2916 8.81373 10.8434 8.36734 10.8434 7.81668V7.01903C10.8434 6.46837 11.2916 6.02197 11.8445 6.02197L21.1959 6.02197C21.7488 6.02197 22.197 6.46837 22.197 7.01903V7.71698C22.197 8.26764 22.6452 8.71404 23.198 8.71404H23.9989C24.5518 8.71404 25 9.16041 25 9.71107V10.6951Z"
      fill={color}
    />
    <path
      d="M25 10.6951H22.197V11.5794C22.197 12.1301 21.7488 12.5765 21.1959 12.5765H11.8445C11.2916 12.5765 10.8434 13.0228 10.8434 13.5735V14.3712C10.8434 14.9218 11.2916 15.3682 11.8445 15.3682H21.1959C21.7488 15.3682 22.197 14.9218 22.197 14.3712V13.6732C22.197 13.1226 22.6452 12.6762 23.198 12.6762H23.9989C24.5518 12.6762 25 12.2298 25 11.6791V10.6951Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2537 11.1156C11.2537 11.6621 11.7054 12.1051 12.2625 12.1051H13.0695C13.6267 12.1051 14.0783 11.6621 14.0783 11.1156V10.2746C14.0783 9.72815 13.6267 9.28516 13.0695 9.28516H12.2625C11.7054 9.28516 11.2537 9.72815 11.2537 10.2746V11.1156Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9217 11.1156C17.9217 11.6621 18.3733 12.1051 18.9305 12.1051H19.7375C20.2947 12.1051 20.7463 11.6621 20.7463 11.1156V10.2746C20.7463 9.72815 20.2947 9.28516 19.7375 9.28516H18.9305C18.3733 9.28516 17.9217 9.72815 17.9217 10.2746V11.1156Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6535 14.1969C19.2106 14.1969 19.6623 14.6399 19.6623 15.1864V15.5327C19.6623 16.0791 20.1139 16.5221 20.6711 16.5221H21.3772C21.9344 16.5221 22.386 16.9651 22.386 17.5115L22.3816 22.2621C22.3816 22.8086 22.8333 23.2515 23.3904 23.2515H23.9912C24.5483 23.2515 25 23.6945 25 24.241V25.0325C25 25.579 24.5483 26.022 23.9912 26.022H15.4714C14.9143 26.022 14.4626 25.579 14.4626 25.0325V24.241C14.4626 23.6945 14.9143 23.2515 15.4714 23.2515H18.5482C19.1054 23.2515 19.557 22.8086 19.557 22.2621L19.5614 17.9568C19.5614 17.4103 19.1098 16.9673 18.5526 16.9673L16.1315 16.9673C15.5744 16.9673 15.1227 16.5244 15.1227 15.9779V15.1864C15.1227 14.6399 15.5744 14.1969 16.1315 14.1969H18.6535Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2206 14.1969C12.6635 14.1969 12.2118 14.6399 12.2118 15.1864V15.5327C12.2118 16.0791 11.7602 16.5221 11.203 16.5221H10.4969C9.93975 16.5221 9.48809 16.9651 9.48809 17.5115L9.48371 22.2621C9.48371 22.8086 9.03206 23.2515 8.47492 23.2515H8.00879C7.45165 23.2515 7 23.6945 7 24.241V25.0325C7 25.579 7.45165 26.022 8.00879 26.022H16.3939C16.9511 26.022 17.4027 25.579 17.4027 25.0325V24.241C17.4027 23.6945 16.9511 23.2515 16.3939 23.2515H13.3171C12.76 23.2515 12.3083 22.8086 12.3083 22.2621L12.3127 17.9568C12.3127 17.4103 12.7644 16.9673 13.3215 16.9673L15.7426 16.9673C16.2997 16.9673 16.7514 16.5244 16.7514 15.9779V15.1864C16.7514 14.6399 16.2997 14.1969 15.7426 14.1969H13.2206Z"
      fill={color}
    />
  </svg>
);

export default AvatarNine;
